import React, { useState, useEffect, useRef } from 'react';
import Jobs_header from '../Header/Jobs_header';
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/Jobs.css";
import small_line from "../../assets/svg/small_line.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import split from "../../assets/svg/split.svg";
import sales from "../../assets/svg/sales.svg";
import cost from "../../assets/svg/cost.svg";
import split_hover from "../../assets/svg/split-b.svg";
import sales_hover from "../../assets/svg/sales-b.svg";
import cost_hover from "../../assets/svg/cost-b.svg";
import { ToastContainer, toast } from "react-toastify"
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import { usePermissions } from '../../hooks/PermissionContext';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';
import DraggableDivider from '../Jobs/DraggableDivider';
import CommonFooter from '../../CommonFooter/CommonFooter';

const Jobs_module = () => {

    let ModuleId = 23
    const { getModulePermission } = usePermissions();
    const { hasAdditionalPermission } = usePermissions();

    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    console.log("permission", permission);

    const hasSales = hasAdditionalPermission(ModuleId, "sales_values");
    const hasCost = hasAdditionalPermission(ModuleId, "cost_values");

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [jobData, setJobData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [allCategories, setAllCategories] = useState([]);

    // If job data is passed via state, use it directly
    const initialJob = state?.job || {};
    const jobId = initialJob.id || initialJob.job_id;
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedSalesRows, setSelectedSalesRows] = useState([]);
    const [selectedCostRows, setSelectedCostRows] = useState([]);
    const [selectAllSales, setSelectAllSales] = useState(false);
    const [selectAllCost, setSelectAllCost] = useState(false);
    const salesRef = useRef(null);
    const costRef = useRef(null);
    const [viewModes, setViewModes] = useState({});
    const [showChargeTypeModal, setShowChargeTypeModal] = useState(false);
    const [invoiceType, setInvoiceType] = useState("");

    useEffect(() => {
        const fetchJobDetails = async () => {
            if (!jobId) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                const response = await axiosInstance.get(`/job/edit/${jobId}`);

                if (response.data && response.data.success) {
                    console.log("Job Data:", response.data.data);
                    const job = response.data.data;
                    setJobData(job);

                    const salesLines = job.sales_lines || [];
                    const costLines = job.cost_lines || [];

                    // Map sales lines
                    const salesRows = salesLines.map(line => ({
                        joblineId: line.id,
                        chargecode: line.charge_code,
                        description: line.description_of_charges,
                        salesunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                        salesRemarks: line.remarks || "",
                        salesRate: parseFloat(line.unit_of_rate) || 0,
                        salesNetTotal: parseFloat(line.net_total) || 0,
                        salesAccrual: parseFloat(line.accrual) || 0,
                        salesAttachmentUrl: line.attachment_url || null,
                        salesStatus: line.sales_status || null,
                        salesContractValue: parseFloat(line.contract_value) || 0,
                        salesInvStatus: line.sales_invoice_status || "",
                        po_wo_number: line.po_wo_number || "",
                        po_wo_date: line.po_wo_date || ""
                    }));

                    // Map cost lines
                    const costRows = costLines.map(line => ({
                        joblineId: line.id,
                        remarks: line.remarks,
                        chargecode: line.charge_code,
                        description: line.description_of_charges,
                        costunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                        vendor: line.vendor_name || "",
                        costRemarks: line.remarks || "",
                        costRate: parseFloat(line.unit_of_rate) || 0,
                        costNetTotal: parseFloat(line.net_total) || 0,
                        costAccrual: parseFloat(line.accrual) || 0,
                        costAttachmentUrl: line.attachment_url || null,
                        costStatus: line.cost_status || null,
                        costContractValue: parseFloat(line.contract_value) || 0,
                        costInvStatus: line.cost_invoice_status || "",
                        po_wo_number: line.po_wo_number || "",
                        po_wo_date: line.po_wo_date || "",
                        vendorInvNumber: line.vendor_inv_number || "",
                        vendorInvDate: line.vendor_inv_date || "",
                    }));

                    // Optionally calculate totals if needed
                    const salesNetTotal = salesRows.reduce((sum, row) => sum + row.salesNetTotal, 0);
                    const salesAccrual = salesRows.reduce((sum, row) => sum + row.salesAccrual, 0);
                    const costNetTotal = costRows.reduce((sum, row) => sum + row.costNetTotal, 0);
                    const costAccrual = costRows.reduce((sum, row) => sum + row.costAccrual, 0);
                    const profitAmount = salesNetTotal - costNetTotal;
                    const profitPercent = costNetTotal > 0
                        ? ((profitAmount / costNetTotal) * 100)
                        : 0;

                    const transformedCategory = {
                        id: job.job_id,
                        jobnumber: job.job_no,
                        salesRows,
                        costRows,
                        salesNetTotal,
                        salesAccrual,
                        costNetTotal,
                        costAccrual,
                        profitAmount,
                        profitPercent
                    };

                    setAllCategories([transformedCategory]);

                } else {
                    // Fallback if job data not found
                    if (Object.keys(initialJob).length > 0) {
                        setJobData(initialJob);
                        const transformedCategory = {
                            id: initialJob.id,
                            jobnumber: initialJob.job_no,
                            salesRows: [],
                            costRows: []
                        };
                        setAllCategories([transformedCategory]);
                    }
                }
            } catch (err) {
                console.error("Error fetching job details:", err);
                if (Object.keys(initialJob).length > 0) {
                    setJobData(initialJob);
                    const transformedCategory = {
                        id: initialJob.id,
                        jobnumber: initialJob.job_no,
                        salesRows: [],
                        costRows: []
                    };
                    setAllCategories([transformedCategory]);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchJobDetails();
    }, [jobId, initialJob]);

    const calculateCategoryTotals = (category) => {
        const salesTotals = category.salesRows.reduce((totals, row) => {
            return {
                quantity: totals.quantity + (parseFloat(row.salesunitQuantity) || 0),
                rate: totals.rate + (parseFloat(row.salesRate) || 0),
                netValue: totals.netValue + (parseFloat(row.salesNetTotal) || 0),
                accrual: totals.accrual + (parseFloat(row.salesAccrual) || 0)
            };
        }, { quantity: 0, rate: 0, netValue: 0, accrual: 0 });

        const costTotals = category.costRows.reduce((totals, row) => {
            return {
                quantity: totals.quantity + (parseFloat(row.costunitQuantity) || 0),
                rate: totals.rate + (parseFloat(row.costRate) || 0),
                netValue: totals.netValue + (parseFloat(row.costNetTotal) || 0),
                accrual: totals.accrual + (parseFloat(row.costAccrual) || 0)
            };
        }, { quantity: 0, rate: 0, netValue: 0, accrual: 0 });

        return {
            sales: salesTotals,
            cost: costTotals,
            profit: {
                netValue: salesTotals.netValue - costTotals.netValue,
                accrual: salesTotals.accrual - costTotals.accrual
            }
        };
    };


    const handleDownload = (attachmentUrl) => {
        // Implement your download logic here
        console.log("Downloading:", attachmentUrl);
        // You can use window.open(attachmentUrl) or implement a proper download
        window.open(attachmentUrl, '_blank');
    };

    if (isLoading) {
        return (
            <>
                <Jobs_header />
                <div className="jobs_module">
                    <div className="loading-container">
                        <p>Loading job details...</p>
                    </div>
                </div>
            </>
        );
    }

    // Handle individual row checkbox change
    const handleRowCheckboxChange = (rowIndex, isChecked) => {
        if (isChecked) {
            setSelectedRows(prev => [...prev, rowIndex]);
        } else {
            setSelectedRows(prev => prev.filter(index => index !== rowIndex));
        }
    };

    const isSalesInvoiced = allCategories.some(category =>
        category.salesRows.some(row =>
            row.salesStatus === 'partially invoiced'
        )
    );

    const isCostInvoiced = allCategories.some(category =>
        category.costRows.some(row =>
            row.costStatus === 'partially invoiced'
        )
    );


    // Handle "select all" checkbox change
    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all rows
            const allRowIndices = allCategories.flatMap(category =>
                [...category.salesRows, ...category.costRows].map((_, index) => index)
            );
            setSelectedRows(allRowIndices);
        } else {
            // Deselect all
            setSelectedRows([]);
        }
    };

    const handleGenerateBill = async (type, costInvoiceType = null) => {
        const selectedRows = type === 'sales' ? selectedSalesRows : selectedCostRows;

        if (selectedRows.length === 0) {
            toast.warning(`Please select at least one ${type} row to generate`);
            return;
        }

        if (!allCategories || allCategories.length === 0) {
            toast.error("No categories found");
            return;
        }

        try {
            const category = allCategories[0];
            const rows = type === 'sales' ? category.salesRows : category.costRows;

            const jobLineIds = selectedRows.map(rowIndex => {
                const row = rows[rowIndex];
                if (!row) throw new Error("Invalid row selected");
                return row.joblineId;
            });

            let endpoint;
            let requestBody = {
                job_id: jobData.job_id,
                job_line_ids: jobLineIds,
            };

            if (type === "cost" && costInvoiceType) {
                requestBody.cost_invoice_type = costInvoiceType;
            }

            if (jobData.status === 'draft') {
                endpoint = 'job/generate_jobDraft_line_to_invoice';
                requestBody.invoice_type = type;
            } else {
                const endpoints = {
                    sales: "job/generate_sales_line_invoice",
                    cost: "job/generate_cost_line_invoice"
                };
                endpoint = endpoints[type];
            }

            const response = await axiosInstance.post(endpoint, requestBody);

            if (response.data.success) {
                toast.success(`${type === 'sales' ? 'Sales' : 'Cost'} bill generated successfully!`);
                const route = type === 'sales' ? '/salesBillPage' : '/costBillPage';
                navigate(route, {
                    state: {
                        billData: response.data
                    }
                });

                // Clear selection after generation
                if (type === 'sales') {
                    setSelectedSalesRows([]);
                    setSelectAllSales(false);
                } else {
                    setSelectedCostRows([]);
                    setSelectAllCost(false);
                }
            } else {
                toast.error(response.data.message || "Failed to generate bill");
            }

        } catch (error) {
            console.error("Error generating bill:", error);
            toast.error(error.response?.data?.message || "Failed to generate bill");
        }
    };

    const getCellBackground = (row, type) => {
        const status = type === "sales" ? row.salesInvStatus : row.costInvStatus;
        const isInvoiced = type === "sales" ? row.salesStatus === 'partially invoiced' : row.costStatus === 'partially invoiced';

        if (isInvoiced) return "#FFF9C4";
        if (!status) return "transparent";

        const statusLower = status.toLowerCase();

        if (statusLower.includes("draft")) return "#FFE5E5";
        if (statusLower.includes("submitted")) return "#D9FFE5";
        if (statusLower.includes("sap pushed")) return "#E0F7FF";
        if (statusLower.includes("final invoice")) return "#E8F5E9";

        return "transparent";
    };


    const isAnySelectedCostInvoiced = selectedRows.some(rowIndex => {
        const row = allCategories[0]?.costRows[rowIndex];
        return row?.costStatus === 'partially invoiced';
    });

    const isAnySelectedSalesInvoiced = selectedRows.some(rowIndex => {
        const row = allCategories[0]?.salesRows[rowIndex];
        return row?.salesStatus === 'partially invoiced';
    });


    const Tooltip = ({ message, children }) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const shouldShow = showTooltip && message;

        return (
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <div
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    {children}
                </div>
                {shouldShow && (
                    <div style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '30%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        zIndex: 100,
                        marginBottom: '5px'
                    }}>
                        {message}
                    </div>
                )}
            </div>
        );
    };

    const handleSalesRowCheckboxChange = (rowIndex, isChecked) => {
        if (isChecked) {
            setSelectedSalesRows(prev => [...prev, rowIndex]);
        } else {
            setSelectedSalesRows(prev => prev.filter(index => index !== rowIndex));
            setSelectAllSales(false);
        }
    };

    // Handle individual cost row checkbox change
    const handleCostRowCheckboxChange = (rowIndex, isChecked) => {
        if (isChecked) {
            setSelectedCostRows(prev => [...prev, rowIndex]);
        } else {
            setSelectedCostRows(prev => prev.filter(index => index !== rowIndex));
            setSelectAllCost(false);
        }
    };

    // Handle "select all" sales checkbox change
    const handleSelectAllSalesChange = (e) => {
        const isChecked = e.target.checked;
        setSelectAllSales(isChecked);

        if (isChecked) {
            // Select all sales rows
            const allSalesRowIndices = allCategories.flatMap(category =>
                category.salesRows.map((_, index) => index)
            );
            setSelectedSalesRows(allSalesRowIndices);
        } else {
            // Deselect all sales rows
            setSelectedSalesRows([]);
        }
    };

    // Handle "select all" cost checkbox change
    const handleSelectAllCostChange = (e) => {
        const isChecked = e.target.checked;
        setSelectAllCost(isChecked);

        if (isChecked) {
            // Select all cost rows
            const allCostRowIndices = allCategories.flatMap(category =>
                category.costRows.map((_, index) => index)
            );
            setSelectedCostRows(allCostRowIndices);
        } else {
            // Deselect all cost rows
            setSelectedCostRows([]);
        }
    };

    const handleViewModeChange = (categoryId, mode) => {
        setViewModes(prev => ({
            ...prev,
            [categoryId]: mode
        }));
    };

    const getViewModeForCategory = (categoryId) => {
        return viewModes[categoryId] || "split";
    };


    return (
        <>
            <Jobs_header onSearch={null} disableSearch={true} />
            <div className='jobs_module'>
                <div className="jobs-module-header">
                    <div className="jobs-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{jobData.job_no || jobData.job_number || 'N/A'}</p>
                    </div>
                </div>

                <div className='jobs-module-details'>
                    <div className='jobs-module-job-details'>
                        <p className='jobs-module-jobs-details-header'>Job details</p>
                        <div className='jobs-module-details-grid'>
                            <p className='jobs-module-jobs-details-label'>Job No</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.job_no || jobData.job_number || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Project</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.project_name || jobData.project || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.date ? new Date(jobData.date).toLocaleDateString() : 'N/A'}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Status</p>
                            <p className='jobs-module-jobs-details-value'>
                                <span className={`status-badge ${jobData.status}`}>
                                    {jobData.status}
                                </span>
                            </p>

                            <p className='jobs-module-jobs-details-label'>Created Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.created_date ? new Date(jobData.created_date).toLocaleDateString() : 'N/A'}
                            </p>


                            {jobData.status !== 'draft' && (
                                <>
                                    <p className='jobs-module-jobs-details-label'>Sales Accrual</p>
                                    <p className='jobs-module-jobs-details-value'>
                                        {Number(jobData.total_sales_accrual).toFixed(2)}
                                    </p>

                                    <p className='jobs-module-jobs-details-label'>Cost Accrual</p>
                                    <p className='jobs-module-jobs-details-value'>
                                        {Number(jobData.total_cost_accrual).toFixed(2)}
                                    </p>
                                </>
                            )}

                            <p className='jobs-module-jobs-details-label'>Supply Period</p>
                            <p className='jobs-module-jobs-details-value'>
                               {jobData.supply_period}
                            </p>

                            {jobData.division_type === "ff" && (
                                <>
                                    <p className='jobs-module-jobs-details-label'>Plant Code</p>
                                    <p className='jobs-module-jobs-details-value'>
                                        {jobData.ff_plant_code || 'N/A'}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='jobs-module-job-types'>
                        <div className='job-types-content'>
                            <p className='jobs-module-jobs-details-header'>Job types</p>
                            <div className='job-types-buttons'>
                                {(jobData.sales_lines?.length > 0
                                    ? [...new Set(jobData.sales_lines.map(line => line.job_type_name))]
                                    : jobData.cost_lines?.length > 0
                                        ? [...new Set(jobData.cost_lines.map(line => line.job_type_name))]
                                        : []
                                ).map((type, index) => (
                                    <button key={index} className='jobs-module-jobs-details-data'>
                                        {type || 'N/A'}
                                    </button>
                                ))}

                                {((jobData.sales_lines?.length > 0 || jobData.cost_lines?.length > 0)
                                    ? null
                                    : <button className='jobs-module-jobs-details-data'>N/A</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
                    {(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'Work Sans' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <p className="invoice-module-summary-summary">Select jobs to generate bill</p>
                                {(selectedSalesRows.length > 0 || selectedCostRows.length > 0) && (
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#555',
                                        backgroundColor: '#f0f0f0',
                                        padding: '5px 10px',
                                        borderRadius: '10px',
                                        fontFamily: 'Work Sans',
                                    }}>
                                        {selectedSalesRows.length} Sales, {selectedCostRows.length} Cost Selected
                                    </span>
                                )}
                            </div>

                            <AdditionalPermissionWrapper permissionKey="job_view_to_generate_invoice" moduleId={ModuleId}>
                                {(selectedSalesRows.length > 0 || selectedCostRows.length > 0) && (
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {selectedSalesRows.length > 0 && (
                                            <Tooltip message={isAnySelectedSalesInvoiced ? "Some selected rows already have sales invoices" : ""}>
                                                <button
                                                    style={{
                                                        backgroundColor: isAnySelectedSalesInvoiced ? '#cccccc' : '#20824A',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '8px 16px',
                                                        borderRadius: '12px',
                                                        cursor: isAnySelectedSalesInvoiced ? 'not-allowed' : 'pointer',
                                                        height: '37px',
                                                        fontWeight: '600',
                                                        fontSize: '12px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}
                                                    onClick={() => !isAnySelectedSalesInvoiced && handleGenerateBill('sales')}
                                                    disabled={isAnySelectedSalesInvoiced}
                                                >
                                                    Generate Sales Invoice
                                                </button>
                                            </Tooltip>
                                        )}

                                        {selectedCostRows.length > 0 && (
                                            <Tooltip message={isAnySelectedCostInvoiced ? "Some selected rows already have cost invoices" : ""}>
                                                <button
                                                    style={{
                                                        backgroundColor: isAnySelectedCostInvoiced ? '#cccccc' : '#097BED',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '8px 16px',
                                                        borderRadius: '12px',
                                                        cursor: isAnySelectedCostInvoiced ? 'not-allowed' : 'pointer',
                                                        height: '37px',
                                                        fontWeight: '600',
                                                        fontSize: '12px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}
                                                    onClick={() => {
                                                        if (isAnySelectedCostInvoiced) return;
                                                        setInvoiceType("");
                                                        setShowChargeTypeModal(true);
                                                    }}
                                                    disabled={isAnySelectedCostInvoiced}
                                                >
                                                    Generate Cost Invoice
                                                </button>
                                            </Tooltip>
                                        )}
                                    </div>
                                )}
                            </AdditionalPermissionWrapper>
                        </div>
                    )}

                    {allCategories.map((category, index) => {
                        const totals = calculateCategoryTotals(category);
                        const anyEnabledSalesRows = category.salesRows.some(row => {
                            const isSalesRowDisabled = ["draft", "submitted", "sap pushed", "final invoice"].includes(row.salesInvStatus);
                            return !isSalesRowDisabled;
                        });
                        const anyEnabledCostRows = category.costRows.some(row => {
                            const isCostRowDisabled = ["draft", "submitted", "sap pushed", "final invoice"].includes(row.costInvStatus);
                            return !isCostRowDisabled;
                        });
                        return (
                            <div key={index} className="invoice_popup_outercategory">
                                <div className="invoice_popup_category_header">
                                    <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* <input type="checkbox" /> */}
                                        <span className="category_name">
                                            Job Type - {jobData.sales_lines && jobData.sales_lines.length > 0
                                                ? [...new Set(jobData.sales_lines.map(line => line.job_type_name))].join(', ')
                                                : jobData.cost_lines && jobData.cost_lines.length > 0
                                                    ? [...new Set(jobData.cost_lines.map(line => line.job_type_name))].join(', ')
                                                    : 'N/A'
                                            }
                                        </span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        gap: "12px",
                                        fontSize: '12px',
                                        flexWrap: "wrap"
                                    }}>
                                        {/* SALES BOX */}
                                        <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: 'auto',
                                            height: '30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                        }}>
                                            <span style={{ color: "green", fontWeight: "600" }}>SALES : </span>
                                            <span style={{ color: "#000" }}>Accrual : ₹ {category.salesAccrual?.toLocaleString()}</span>
                                            <span style={{
                                                width: "1px",
                                                backgroundColor: "#ccc",
                                                alignSelf: "stretch"
                                            }}></span>
                                            <span style={{ color: "#000" }}>Net Total : ₹ {category.salesNetTotal?.toLocaleString()}</span>
                                        </div>

                                        <div style={{
                                            width: "1px",
                                            backgroundColor: "#ccc",
                                            alignSelf: "stretch"
                                        }} />

                                        {/* COST BOX */}
                                        <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: 'auto',
                                            height: '30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                        }}>
                                            <span style={{ color: "#007bff", fontWeight: "600" }}>COST : </span>
                                            <span style={{ color: "#000" }}>Accrual : ₹ {category.costAccrual?.toLocaleString()}</span>
                                            <span style={{
                                                width: "1px",
                                                backgroundColor: "#ccc",
                                                alignSelf: "stretch"
                                            }}></span>
                                            <span style={{ color: "#000" }}>Net total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                                        </div>

                                        <div style={{
                                            width: "1px",
                                            backgroundColor: "#ccc",
                                            alignSelf: "stretch"
                                        }} />

                                        <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: 'auto',
                                            height: '30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                        }}>
                                            <span style={{ color: "purple", fontWeight: "600" }}>PROFIT : </span>
                                            <span style={{ color: "#000" }}>Amount : ₹{category.profitAmount?.toLocaleString()}</span>
                                            <span style={{ color: "purple", fontWeight: "600" }}>PROFIT % :</span>
                                            <span style={{ color: "#000" }}>{category.profitPercent?.toLocaleString()}%</span>
                                        </div>
                                    </div>

                                </div>

                                <div className="invoice_popup_category_subheader">
                                    <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                        <AdditionalPermissionWrapper permissionKey="sales_values" moduleId={ModuleId}>
                                            <AdditionalPermissionWrapper permissionKey="cost_values" moduleId={ModuleId}>

                                                <div style={{
                                                    display: "flex",
                                                    gap: "12px",
                                                    fontSize: '12px',
                                                    flexWrap: "wrap",
                                                    flexGrow: 1,
                                                    justifyContent: "flex-start",
                                                    minWidth: "min-content",
                                                    padding: '10px',
                                                    cursor: 'pointer',
                                                    fontWeight: '600'
                                                }}>
                                                    <div onClick={() => handleViewModeChange(category.id, "split")} style={{
                                                        backgroundColor: getViewModeForCategory(category.id) === "split" ? "#D0E6FF" : "#EDF3F9",
                                                        borderRadius: "10px",
                                                        padding: "12px 16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        height: '30px',
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        flexShrink: 0,
                                                        color: getViewModeForCategory(category.id) === "split" ? "#007bff" : "",
                                                        transition: "all 0.3s ease",
                                                    }}>
                                                        <img src={getViewModeForCategory(category.id) === "split" ? split_hover : split} alt="Split View" />
                                                        <span style={{ transition: "color 0.3s ease" }}>Split View</span>
                                                    </div>
                                                    <div style={{
                                                        width: "1px",
                                                        backgroundColor: "#ccc",
                                                        alignSelf: "stretch",
                                                        flexShrink: 0
                                                    }} />
                                                    <div onClick={() => handleViewModeChange(category.id, "sales")} style={{
                                                        backgroundColor: getViewModeForCategory(category.id) === "sales" ? "#D0E6FF" : "#EDF3F9",
                                                        borderRadius: "10px",
                                                        padding: "12px 16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        height: '30px',
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        flexShrink: 0,
                                                        color: getViewModeForCategory(category.id) === "sales" ? "#007bff" : "",
                                                        transition: "all 0.3s ease",
                                                    }}>
                                                        <img src={getViewModeForCategory(category.id) === "sales" ? cost_hover : cost} alt="Sales View" />
                                                        <span style={{ transition: "color 0.3s ease" }}>Sales View</span>
                                                    </div>
                                                    <div style={{
                                                        width: "1px",
                                                        backgroundColor: "#ccc",
                                                        alignSelf: "stretch",
                                                        flexShrink: 0
                                                    }} />
                                                    <div onClick={() => handleViewModeChange(category.id, "cost")} style={{
                                                        backgroundColor: getViewModeForCategory(category.id) === "cost" ? "#D0E6FF" : "#EDF3F9",
                                                        borderRadius: "10px",
                                                        padding: "12px 16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        height: '30px',
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                        flexShrink: 0,
                                                        color: getViewModeForCategory(category.id) === "cost" ? "#007bff" : "",
                                                        transition: "all 0.3s ease",
                                                    }}>
                                                        <img src={getViewModeForCategory(category.id) === "cost" ? sales_hover : sales} alt="Sales View" />
                                                        <span style={{ transition: "color 0.3s ease" }}>Cost View</span>
                                                    </div>
                                                </div>
                                            </AdditionalPermissionWrapper>
                                        </AdditionalPermissionWrapper>
                                        <div className="tables-wrapper">
                                            <AdditionalPermissionWrapper permissionKey="sales_values" moduleId={ModuleId}>
                                                {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "sales") && (
                                                    <div className="table-containers sales-table" ref={salesRef} style={{
                                                        position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth',
                                                        flex: getViewModeForCategory(category.id) === "split" ? hasCost
                                                            ? "0 0 50%"
                                                            : "1 1 100%"
                                                            : "1 1 100%",
                                                        width: getViewModeForCategory(category.id) === "split" ? "50%" : "100%", transition: 'flex 0.2s ease',
                                                        display: getViewModeForCategory(category.id) === "split" ? "block" :
                                                            (getViewModeForCategory(category.id) === "sales" ? "block" : "none")
                                                    }}>
                                                        <table className="invoice_table">
                                                            <thead>
                                                                <tr>
                                                                    {(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') && (
                                                                        <th rowSpan="2">
                                                                            <input
                                                                                type="checkbox"
                                                                                style={{
                                                                                    width: "12px",
                                                                                    height: "12px",
                                                                                    borderRadius: "2px",
                                                                                }}
                                                                                checked={selectAllSales}
                                                                                onChange={handleSelectAllSalesChange}
                                                                                disabled={!anyEnabledSalesRows}
                                                                            />
                                                                        </th>
                                                                    )}
                                                                    <th colSpan="12" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                                                                </tr>
                                                                <tr>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>CHARGE CODE</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>DESCRIPTION</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO NO</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO Date</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2', padding: '10px' }}>REMARKS</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>ACCRUAL SPLIT</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>CONTRACT VALUE</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>QUANTITY</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>RATE</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>NET TOTAL</th>
                                                                    <th style={{ backgroundColor: '#D9FFE2' }}>ATTACHMENT</th>
                                                                    {jobData.status !== 'draft' && (
                                                                        <th style={{ backgroundColor: '#D9FFE2' }}>INV STATUS</th>
                                                                    )}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {category.salesRows.length > 0 ? (
                                                                    category.salesRows.map((row, rowIndex) => {
                                                                        const isSalesInvoiced = row.salesStatus === 'partially invoiced';
                                                                        const isCostInvoiced = row.costStatus === 'partially invoiced';
                                                                        const isSalesRowDisabled = ["draft", "submitted", "sap pushed", "final invoice"].includes(row.salesInvStatus);

                                                                        return (

                                                                            <tr key={rowIndex}>
                                                                                {(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') && (
                                                                                    <td style={{
                                                                                        backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                        background: getCellBackground(row, "sales")
                                                                                    }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            disabled={isSalesRowDisabled}
                                                                                            checked={selectedSalesRows.includes(rowIndex)}
                                                                                            onChange={(e) => {
                                                                                                if (!isSalesRowDisabled) {
                                                                                                    handleSalesRowCheckboxChange(rowIndex, e.target.checked);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </td>
                                                                                )}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                                            value={row.chargecode}
                                                                                            className="invoice_narrow_input_chargecode"
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.chargecode || '-'}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                                            value={row.description}
                                                                                            className="invoice_narrow_input_description"
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.description || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.po_wo_number}
                                                                                            className="invoice_narrow_input_remarks"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.po_wo_number || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>


                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <input
                                                                                        type="date"
                                                                                        value={row.po_wo_date}
                                                                                        className="invoice_narrow_input_remarks"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.salesRemarks}
                                                                                            className="invoice_narrow_input_remarks"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.salesRemarks || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>

                                                                                {/* SALES accrualSplit */}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.salesAccrual}
                                                                                        className="invoice_narrow_input"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                {/* SALES ContractValue */}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        value={row.salesContractValue}
                                                                                        className="invoice_narrow_input_quantity"
                                                                                        readOnly />
                                                                                </td>
                                                                                {/* SALES QUANTITY */}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        value={row.salesunitQuantity}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly />
                                                                                </td>
                                                                                {/* SALES RATE */}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>

                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.salesRate}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                    />

                                                                                </td>
                                                                                {/* SALES NET TOTAL */}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.salesNetTotal}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                    />
                                                                                </td>
                                                                                {/* SALES  ATTACHMENT*/}
                                                                                <td style={{
                                                                                    backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "sales")
                                                                                }}>
                                                                                    {row.salesAttachmentUrl && (
                                                                                        <div className="file_upload_wrapper">
                                                                                            <div className="download_file_item">
                                                                                                <button
                                                                                                    onClick={() => handleDownload(row.salesAttachmentUrl)}
                                                                                                    className="download_btn"
                                                                                                    style={{ height: 'auto', width: 'auto', padding: '8px' }}
                                                                                                >
                                                                                                    <img src={download_arrow} alt="Download" className="file_icon" />
                                                                                                    <span className="download_text">Download</span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                                {/* SALES INVOICE STATUS */}
                                                                                {jobData.status !== 'draft' && (
                                                                                    <td style={{
                                                                                        backgroundColor: isSalesInvoiced ? '#FFF9C4' : 'transparent',
                                                                                        background: getCellBackground(row, "sales")
                                                                                    }}>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.salesInvStatus}
                                                                                            className="contracts_small_input"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                                            readOnly
                                                                                        />
                                                                                    </td>
                                                                                )}
                                                                            </tr>
                                                                        )

                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') ? 11 : 10}
                                                                            style={{ textAlign: 'center', padding: '15px', color: '#999' }}>
                                                                            No available data
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </AdditionalPermissionWrapper>

                                            <AdditionalPermissionWrapper permissionKey="sales_values" moduleId={ModuleId}>
                                                <AdditionalPermissionWrapper permissionKey="cost_values" moduleId={ModuleId}>
                                                    {(getViewModeForCategory(category.id) === "split") && <DraggableDivider leftRef={salesRef} rightRef={costRef} />}
                                                </AdditionalPermissionWrapper>
                                            </AdditionalPermissionWrapper>

                                            <AdditionalPermissionWrapper permissionKey="cost_values" moduleId={ModuleId}>
                                                {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "cost") && (
                                                    <div className="table-containers cost-table" ref={costRef} style={{
                                                        position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth',
                                                        // flex: getViewModeForCategory(category.id) === "split" ? "1 1 0px" : "1 1 100%",
                                                        flex: getViewModeForCategory(category.id) === "split" ? hasSales
                                                            ? "0 0 50%"
                                                            : "1 1 100%"
                                                            : "1 1 100%",

                                                        width: getViewModeForCategory(category.id) === "split" ? "auto" : "100%", transition: 'flex 0.2s ease',
                                                        display: getViewModeForCategory(category.id) === "split" ? "block" :
                                                            (getViewModeForCategory(category.id) === "cost" ? "block" : "none")
                                                    }}>
                                                        <table className="invoice_table">
                                                            <thead>
                                                                <tr>
                                                                    {(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') && (
                                                                        <th rowSpan="2">
                                                                            <input
                                                                                type="checkbox"
                                                                                style={{
                                                                                    width: "14px",
                                                                                    height: "14px",
                                                                                    borderRadius: "2px",
                                                                                }}
                                                                                checked={selectAllCost}
                                                                                onChange={handleSelectAllCostChange}
                                                                                disabled={!anyEnabledCostRows}
                                                                            />
                                                                        </th>
                                                                    )}

                                                                    <th colSpan="15" style={{ backgroundColor: '#E0EFFF', padding: '10px', color: '#097BED' }}>COST</th>
                                                                </tr>
                                                                <tr>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>CHARGE CODE</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>DESCRIPTION</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV NUMBER</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV DATE</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF', padding: '10px' }}>REMARKS</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>ACCRUAL SPLIT</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>CONTRACT VALUE</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>QUANTITY</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>RATE</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>NET TOTAL</th>
                                                                    <th style={{ backgroundColor: '#E0EFFF' }}>ATTACHMENT</th>
                                                                    {jobData.status !== 'draft' && (
                                                                        <th style={{ backgroundColor: '#E0EFFF' }}>INV STATUS</th>
                                                                    )}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {category.costRows.length > 0 ? (
                                                                    category.costRows.map((row, rowIndex) => {
                                                                        const isCostInvoiced = row.costStatus === 'partially invoiced';
                                                                        const isCostRowDisabled = ["draft", "submitted", "sap pushed", "final invoice"].includes(row.costInvStatus);
                                                                        return (

                                                                            <tr key={rowIndex}>
                                                                                {(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') && (
                                                                                    <td style={{
                                                                                        backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                        background: getCellBackground(row, "cost")
                                                                                    }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            disabled={isCostRowDisabled}
                                                                                            checked={selectedCostRows.includes(rowIndex)}
                                                                                            onChange={(e) => {
                                                                                                if (!isCostRowDisabled) {
                                                                                                    handleCostRowCheckboxChange(rowIndex, e.target.checked);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </td>
                                                                                )}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                                            value={row.chargecode}
                                                                                            className="invoice_narrow_input_chargecode"
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.chargecode || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                                            value={row.description}
                                                                                            className="invoice_narrow_input_description"
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.description || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                {/* COST  VENDOR*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.vendor}
                                                                                            className="invoice_narrow_input_description"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                            readOnly
                                                                                        />  <span className="add-contract-tooltip">
                                                                                            {row.vendor || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>

                                                                                {/* Vendor Inv Number */}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        value={row.vendorInvNumber}
                                                                                        className="invoice_narrow_input"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                  {/* Vendor Inv Date */}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="date"
                                                                                        value={row.vendorInvDate}
                                                                                        className="invoice_narrow_input"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                 {/* PO WO Number */}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.po_wo_number}
                                                                                            className="invoice_narrow_input_remarks"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.po_wo_number || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="date"
                                                                                        value={row.po_wo_date}
                                                                                        className="invoice_narrow_input_remarks"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                {/* COST  REMARKS*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <div className="table-tooltip-container">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.costRemarks}
                                                                                            className="invoice_narrow_input_remarks"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                            readOnly
                                                                                        />
                                                                                        <span className="add-contract-tooltip">
                                                                                            {row.costRemarks || "-"}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                {/* COST  ACCURAL*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.costAccrual}
                                                                                        className="invoice_narrow_input"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                {/* COST CONTRACT VALUE */}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                        value={row.costContractValue}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly />
                                                                                </td>
                                                                                {/* COST QUANTITY */}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                                        value={row.costunitQuantity}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly />
                                                                                </td>
                                                                                {/* COST  RATE*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>

                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.costRate}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                    />

                                                                                </td>
                                                                                {/* COST  NET TOTAL*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={row.costNetTotal}
                                                                                        className="invoice_narrow_input"
                                                                                        readOnly
                                                                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                                    />
                                                                                </td>
                                                                                {/* COST  ATTACHMENT*/}
                                                                                <td style={{
                                                                                    backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                    background: getCellBackground(row, "cost")
                                                                                }}>
                                                                                    {row.costAttachmentUrl && (
                                                                                        <div className="file_upload_wrapper">
                                                                                            <div className="download_file_item">
                                                                                                <button
                                                                                                    onClick={() => handleDownload(row.costAttachmentUrl)}
                                                                                                    className="download_btn"
                                                                                                    style={{ height: 'auto', width: 'auto', padding: '8px' }}
                                                                                                >
                                                                                                    <img src={download_arrow} alt="Download" className="file_icon" />
                                                                                                    <span className="download_text">Download</span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                                {jobData.status !== 'draft' && (
                                                                                    <td style={{
                                                                                        backgroundColor: isCostInvoiced ? '#FFF9C4' : 'transparent',
                                                                                        background: getCellBackground(row, "cost")
                                                                                    }}>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={row.costInvStatus}
                                                                                            className="contracts_small_input"
                                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                                            readOnly
                                                                                        />
                                                                                    </td>
                                                                                )}
                                                                            </tr>
                                                                        )

                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={(jobData.status === 'submitted' || jobData.status === 'partially invoiced' || jobData.status === 'draft') ? 12 : 11}
                                                                            style={{ textAlign: 'center', padding: '15px', color: '#999' }}>
                                                                            No available data
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </AdditionalPermissionWrapper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
            <CommonFooter />
            {showChargeTypeModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: 'auto',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }}>
                        <h3 style={{
                            marginBottom: '16px',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#1f2937'
                        }}>
                            Generate Cost Bill
                        </h3>

                        <div style={{
                            padding: '16px',
                            backgroundColor: '#f9fafb',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            border: '1px solid #e5e7eb'
                        }}>
                            <p style={{
                                fontSize: '14px',
                                color: '#6b7280',
                                marginBottom: 0,
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '8px',
                                lineHeight: '1.6'
                            }}>
                                <span className="combine-charges-info-icon">!</span>
                                The selected Job include both Material Code and GL Code charges,<br />
                                please choose how you want to generate the cost bill.  </p>
                        </div>

                        <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                            <div>
                                <label className="pill-option">
                                    <input
                                        type="radio"
                                        name="poType"
                                        checked={invoiceType === "po"}
                                        onChange={() => setInvoiceType("po")}
                                    />
                                    <span className="po-custom-radio"></span>
                                    <span className="po-custom-text">PO</span>
                                </label>
                            </div>

                            <div>
                                <label className="pill-option">
                                    <input
                                        type="radio"
                                        name="poType"
                                        checked={invoiceType === "non_po"}
                                        onChange={() => setInvoiceType("non_po")}
                                    />
                                    <span className="po-custom-radio"></span>
                                    <span className="po-custom-text">Non-PO</span>
                                </label>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px'
                        }}>
                            <button
                                onClick={() => setShowChargeTypeModal(false)}
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '6px 14px',
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    height: '32px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    fontFamily: "'Work Sans', sans-serif",
                                    boxShadow: '0 2px 6px rgba(108, 117, 125, 0.3)',
                                    transition: 'background-color 0.2s, transform 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#565e64';
                                    e.target.style.transform = 'translateY(-1px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#6c757d';
                                    e.target.style.transform = 'translateY(0)';
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    if (!invoiceType) {
                                        toast.warning("Please Choose the Billing Type");
                                        return;
                                    } setShowChargeTypeModal(false);
                                    handleGenerateBill("cost", invoiceType);
                                }}
                                style={{
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '6px 14px',
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    height: '32px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    fontFamily: "'Work Sans', sans-serif",
                                    boxShadow: '0 2px 6px rgba(0, 123, 255, 0.3)',
                                    transition: 'background-color 0.2s, transform 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#0056b3';
                                    e.target.style.transform = 'translateY(-1px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#007bff';
                                    e.target.style.transform = 'translateY(0)';
                                }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Jobs_module